import React from "react";
import { FaGoogle,FaBookOpen,FaCertificate,FaHubspot } from "react-icons/fa";


import CertyficateRow from "./certificateComponents/CertificateRow";

import Google_1 from "../../../../../../documents/Google_1.png";
import Google_Youtube from "../../../../../../documents/Google_Youtube.png";
import google_cert1 from "../../../../../../documents/google_cert1.png";
import google4 from "../../../../../../documents/google4.png";
import googleCodeIn from "../../../../../../documents/googleCodeIn.png";
import google5 from "../../../../../../documents/google5.png";
import google6 from "../../../../../../documents/google5.png";
import google7 from "../../../../../../documents/google6.png";
import google8 from "../../../../../../documents/google7.png";
import google from "../../../../../../documents/google.png";
import google9 from "../../../../../../documents/google9.png";
import google10 from "../../../../../../documents/google10.png";
import google11 from "../../../../../../documents/google11.png";
import google12 from "../../../../../../documents/google12.png";
import tcs1 from "../../../../../../documents/tcs1.png";
import tcs2 from "../../../../../../documents/tcs2.png";
import hubs1 from "../../../../../../documents/hubs1.png";
import hubs2 from "../../../../../../documents/hubs2.png";
import hubs3 from "../../../../../../documents/hubs3.png";
import hubs4 from "../../../../../../documents/hubs4.png";
import hubs5 from "../../../../../../documents/hubs5.png";

import udemy3 from "../../../../../../documents/udemy3.png";

import udemy7 from "../../../../../../documents/udemy7.png";




const certificateList = [
  {
    name: "Google Analytics",
    date: "13.01.2020",
    certyficate: Google_1,
    icon: <FaGoogle />,
  },
  {
    name: "Google - Youtube",
    date: "20.01.2020",
    certyficate: Google_Youtube,
    icon: <FaGoogle />,
  },
  {
    name: "Google - creative",
    date: "21.01.2020",
    certyficate: google_cert1,
    icon: <FaGoogle />,
  },
  {
    name: "Google - Ads",
    date: "22.02.2020",
    certyficate: google4,
    icon: <FaGoogle />,
  },
  {
    name: "Google Code-In 2019",
    date: "30.05.2019",
    certyficate: googleCodeIn,
    icon: <FaGoogle />,
  },
  {
    name: "Google - Cloud",
    date: "16.09.2019",
    certyficate: google5,
    icon: <FaGoogle />,
  },
  {
    name: "Google - Analytics",
    date: "11.02.2020",
    certyficate: google6,
    icon: <FaGoogle />,
  },
  {
    name: "Google - Tag Manager",
    date: "13.02.2020",
    certyficate: google7,
    icon: <FaGoogle />,
  },
  {
    name: "Google - Data Studio",
    date: "19.02.2020",
    certyficate: google8,
    icon: <FaGoogle />,
  },
  {
    name: "Google - Analytics 360",
    date: "11.02.2020",
    certyficate: google,
    icon: <FaGoogle />,
  },
  {
    name: "Google - Analytics",
    date: "30.02.2020",
    certyficate: google9,
    icon: <FaGoogle />,
  },
  {
    name: "Google - Digital Unlocked",
    date: "02.02.2020",
    certyficate: google10,
    icon: <FaGoogle />,
  },
  {
    name: "Google - Analytics",
    date: "14.02.2020",
    certyficate: google11,
    icon: <FaGoogle />,
  },
  {
    name: "Google - Ananlytics",
    date: "06.08.2020",
    certyficate: google12,
    icon: <FaGoogle />,
  },
  {
    name: "TCS - InsighT 2020",
    date: "19.08.2019",
    certyficate: tcs1,
    icon: <FaBookOpen />,
  },
  {
    name: "TCS - Insight 2020 2",
    date: "19.10.2019",
    certyficate: tcs2,
    icon: <FaBookOpen />,
  },
  {
    name: "Hubspot - Design Agencies",
    date: "02.02.2020",
    certyficate: hubs1,
    icon: <FaHubspot />,
  },
  {
    name: "Hubspot - Social Media",
    date: "14.02.2020",
    certyficate: hubs2,
    icon: <FaHubspot />,
  },
  {
    name: "Hubspot - Email Marketing ",
    date: "06.02.2020",
    certyficate: hubs3,
    icon: <FaHubspot />,
  },
  {
    name: "Hunspot - Frictionless sales",
    date: "19.02.2020",
    certyficate: hubs4,
    icon: <FaHubspot />,
  },
  {
    name: "Hubspot - Email Marketing",
    date: "03.03.2020",
    certyficate: hubs5,
    icon: <FaHubspot />,
  },
  {
    name: "Udemy - Advanced Python",
    date: "14.03.2020",
    certyficate: udemy3,
    icon: <FaCertificate />,
  },
  {
    name: "Udemy - Android ",
    date: "06.04.2020",
    certyficate: udemy7,
    icon: <FaCertificate />,
  },


  
];

const Certificates = (props) => {
  let sortedDesc = certificateList.sort(
    (a, b) =>
      Date.parse(new Date(b.date.split(".").reverse().join("-"))) -
      Date.parse(new Date(a.date.split(".").reverse().join("-")))
  );

  const getCertificates = sortedDesc.map((item, index) => (
    <CertyficateRow
      key={"cert" + item.name + index}
      date={item.date}
      text={item.name}
      certyficate={item.certyficate}
      icon={item.icon}
      first={index === 0 ? true : false}
      last={index + 1 === certificateList.length ? true : false}
    />
  ));

  return <>{getCertificates}</>;
};

export default React.memo(Certificates);
